import React from 'react';
import { Box } from 'components/mui';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { PayrollFilters, PayrollTable } from 'containers/pages/payrollReport/components';
import { usePayrollReport } from 'containers/pages/payrollReport/hooks';

function PayrollReport() {
  const { state, handler } = usePayrollReport();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      <PayrollFilters
        params={state.params}
        onParamsChange={handler.onParamsChange}
        isAdmin={state.isAdmin}
        consultantOptions={state.consultantOptions}
        consultantLoading={state.consultantLoading}
        onConsultantSearch={handler.onConsultantSearch}
        onConsultantSelect={handler.onConsultantSelect}
      />

      {state.canFetch && (
        <PayrollTable
          dateGroups={state.dateGroups}
          reportType={state.params.ReportType as 'guard' | 'consultant'}
          consultantName={state.params.ConsultantName || ''}
          startDate={state.params.StartDate}
          endDate={state.params.EndDate}
          grandTotal={state.grandTotal}
          isLoading={state.isLoading}
          hasFetched={state.hasFetched}
        />
      )}

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default PayrollReport;
